import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import CustomButton from "../../ui/button/Button";

const ConfirmDialog = ({ open, title, content, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>{title}</DialogTitle>
    <DialogContent>{content}</DialogContent>
    <DialogActions>
      <CustomButton
        background={"#FFFFFF"}
        color={"#223D51"}
        text="Cancelar"
        height="40px"
        fontWeight="700"
        fontSize="14px"
        border="1px solid #D9D9D9"
        type="button"
        width={"100px"}
        onClick={onClose}
      />
      <CustomButton
        background={"#223D51"}
        color={"#FFFFFF"}
        text="Aceptar"
        height="40px"
        fontWeight="700"
        fontSize="14px"
        border="1px solid #D9D9D9"
        onClick={onConfirm}
        type="button"
        width={"100px"}
      />
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
